import { KendraConst, SearchInterface } from "@amzn/ask-legal-domain";
import { Select, SelectProps } from "@amzn/awsui-components-react";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import {
    ANY_TIME,
    getSelectedPeriod,
    LAST_UPDATED_PERIODS,
    MS_IN_DAY,
    replaceMinDateFilter
} from "./search-filter-utils-v2";

const LAST_UPDATED = KendraConst.ContainerIngestionKendraAttributes.Default.LastUpdatedDate;

const OPTIONS: SelectProps.Option[] = [
    { label: "Any time", value: ANY_TIME },
    ...LAST_UPDATED_PERIODS.map(p => ({ label: p.label, value: p.value }))
];

export const LastUpdatedDateFilterV2 = (props: {
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    disabled?: boolean;
}) => {
    const selectedValue = getSelectedPeriod(props.queryInputState.value);

    const onChange = (value: string | undefined) => {
        const period = LAST_UPDATED_PERIODS.find(p => p.value === value);
        props.queryInputState.setValue(replaceMinDateFilter(
            props.queryInputState.value,
            LAST_UPDATED,
            period ? new Date(Date.now() - period.days * MS_IN_DAY) : undefined
        ));
    };

    return (
        <Select
            inlineLabelText="Last updated"
            selectedOption={OPTIONS.find(o => o.value === selectedValue) || OPTIONS[0]}
            options={OPTIONS}
            disabled={props.disabled}
            onChange={({ detail }) => onChange(detail.selectedOption.value)}
            selectedAriaLabel="Selected"
        />
    );
};
